const formatTreeData = arr => {
	var tree = [],
		mappedArr = {},
		arrElem,
		mappedElem;

	// First map the nodes of the array to an object -> create a hash table.
	for (var i = 0, len = arr.length; i < len; i++) {
		arrElem = {
			...arr[i],
			data: { ...arr[i] },
			text: arr[i].name
		};
		mappedArr[arrElem.id] = arrElem;
		mappedArr[arrElem.id]["children"] = [];
	}

	for (var id in mappedArr) {
		if (mappedArr.hasOwnProperty(id)) {
			mappedElem = mappedArr[id];
			// If the element is not at the root level, add it to its parent array of children.
			if (mappedElem.parent_id && mappedArr[mappedElem["parent_id"]]) {
				mappedArr[mappedElem["parent_id"]]["children"].push(mappedElem);
			}
			// If the element is at the root level, add it to first level elements array.
			else {
				tree.push(mappedElem);
			}
		}
	}
	return tree;
};

export default {
	getTreeInventories: state => {
		return formatTreeData(state.titles);
	}
};
